import React from 'react';
import Layout from '../components/Layout';
import Main from '../components/Main';

const Home: React.FC = () => (
  <Layout>
    <Main />
  </Layout>
);

export default Home;
